import { handleUpdateProjectResource } from '@/service/projectService';
import Utils from '@/common/utils/utils';
import { I18n } from 'aws-amplify';
import Constant from '@/common/constant/Constant';

export const getValue = (data, fieldName) => {
    if (Utils.isEmptyObject(data)) return null;
    return data[fieldName];
};

export const onSubmitSetting = async (submitArgs) => {
    const {
        projectDetail,
        settingData,
        enqueueSnackbar,
        setIsLoading,
        setReloadPage,
        userId,
        setIsChangeData,
        API,
        setIsShowDialogReload,
        isShowLogAiChat = false,
        setProjectInUseDetail,
        temperatureValue,
        maxAiChatKnowledgeCountValue
    } = submitArgs;
    try {
        setIsLoading(true);
        
        let updateDto = {
            usageRange: usageRangeSettingAI(settingData),
            isShowLogAiChat: isShowLogAiChat,
            temperature: temperatureValue,
            maxAiChatKnowledgeCount: maxAiChatKnowledgeCountValue
        }

        const params = {
            settingAI: JSON.stringify(updateDto),
            method: Constant.UPDATE_PROJECT_RESOURCE_METHOD.SETTING_AI,
            corporationId: projectDetail.affiliationOrganization,
            projectId: projectDetail.id,
            userId
        }

        const updatedProject = await handleUpdateProjectResource(API, params);
        if(!updatedProject) {
            enqueueSnackbar(I18n.get('SYSMSG001'), {
                variant: 'error',
                autoHideDuration: 3000,
            });
            setIsLoading(false);
            return ;
        }
        if (!updatedProject.status) {
            setIsLoading(false);
            setIsShowDialogReload(true);
            return;
        }
        enqueueSnackbar(I18n.get('COMMSG045'), {
            variant: 'success',
            autoHideDuration: 3000,
        });

        const projectUpdated = Utils.convertJSONDataToObject(updatedProject.data)
        setProjectInUseDetail(projectUpdated);

        setIsLoading(false);
        setIsChangeData(false);
        setReloadPage(Date.now().toString());

    } catch (error) {
        console.log('HandleUpdateProjectResource :>> error :>>', error);
    }
};

let usageRangeSettingAI = (settingData) => {
    let range = [];
    if (settingData.isInProject) {
        range.push(Constant.AI_SETTING_RANGE.IN_PROJECT);
    }
    if (settingData.isInOrg) {
        range.push(Constant.AI_SETTING_RANGE.IN_ORG);
    }
    if (settingData.isOutOrg) {
        range.push(Constant.AI_SETTING_RANGE.OUT_ORG);
    }
    return range;
}

export const validateTemperature = (value) => {
    // validate
    let errorMsg = ''
    if (Utils.isEmptyString(value)) {
        return I18n.get('MSG-CM-REQUIRED-INPUT')
    }
    const regexDecimal = /^[0-9]+(\.[0-9]+)?$/;
    if (!regexDecimal.test(value)) {
        errorMsg = I18n.get('MSG-AI-INVALID-TEMPERATURE-VALUE');
    }
    const [integerPart, decimalPart] = value.split('.');
    if (
        (!Utils.isEmptyString(integerPart) && integerPart.length > 1) ||
        (!Utils.isEmptyString(decimalPart) && decimalPart.length > 1) ||
        (!Utils.isEmptyString(integerPart) && integerPart > 1) ||
        (integerPart >= 1 && decimalPart > 0)
    ) {
        errorMsg = I18n.get('MSG-AI-INVALID-TEMPERATURE-VALUE');
    }
    return errorMsg
}

export const validateMaxAiChatKnowledgeCount = (value) => {
    // validate
    if (Utils.isEmptyString(value)) {
        return I18n.get('MSG-CM-REQUIRED-INPUT')
    }
    const regexInteger = /^[0-9]+$/;
    if (!regexInteger.test(value)) {
        return I18n.get('MSG-AI-INVALID-KNOWLEDGE-BASE-NUMBER');
    }
    const intValue = parseInt(value, 10);
    if (intValue < Constant.MAX_AI_CHAT_KNOWLEDGE_COUNT_MIN) {
        return I18n.get('MSG-AI-INVALID-KNOWLEDGE-BASE-NUMBER');
    }
    if (intValue > Constant.MAX_AI_CHAT_KNOWLEDGE_COUNT_MAX) {
        return I18n.get('MSG-AI-INVALID-KNOWLEDGE-BASE-NUMBER');
    }
    return ''
}
